/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class GenerateNetworkTopologyRequest {
    getFixupPrototypeFunction() { return GenerateNetworkTopologyRequest.fixupPrototype; }

    static newInstance(model: Partial<GenerateNetworkTopologyRequest>): GenerateNetworkTopologyRequest {
        let obj = Object.assign(new GenerateNetworkTopologyRequest(), model);
        GenerateNetworkTopologyRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<GenerateNetworkTopologyRequest>): GenerateNetworkTopologyRequest {
        if (!model) return null;
        return GenerateNetworkTopologyRequest.newInstance(<GenerateNetworkTopologyRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: GenerateNetworkTopologyRequest) {
        if (!obj) return;

        models.GenerateNetworkTopologyRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: GenerateNetworkTopologyRequest): boolean {
        Object.setPrototypeOf(obj, GenerateNetworkTopologyRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * ID of the workload to generate the network topology for.
     */
    workload_id: string;

}
